module.exports = __webpack_public_path__ + "static/media/AdobeStock_428089463-1-scaled 3.ddfd4fc6.png";